import { InputType } from "../components/sop/inputPanel";

const formFields = {
  endpoint: "conclusion",
  inputs: [
    {
      name: "conclusion",
      label: "Greetings for Conclusion",
      placeholder: "Thank you",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: false,
    },
    {
      name: "other_info",
      label: "Any other additional information for conclusion ?",
      placeholder: " ",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 200,
      required: false,
    },
  ],
};
export default formFields;
